// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-gauge';

export const Component = () => (
  <path d='M11 1c6.075 0 11 4.925 11 11 0 3.249-1.409 6.169-3.648 8.183l-.805-.624A9.977 9.977 0 0 0 21 12c0-5.523-4.477-10-10-10S1 6.477 1 12a9.977 9.977 0 0 0 3.454 7.56l-.806.623A10.972 10.972 0 0 1 0 12C0 5.925 4.925 1 11 1Zm5.011 5.676.811.585-4.436 6.155a1.75 1.75 0 1 1-.81-.585l4.435-6.155ZM11 13.734a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM5 12v1H3v-1h2Zm.51-5.678 1.416 1.412-.706.708-1.416-1.411.706-.709ZM11.5 4v2h-1V4h1Z' />
);

export const viewBox = '0 0 22 22';
